var checkbox = document.querySelector("input[name=warrantyCheckbox]");
// console.log("checkbox")
checkbox.addEventListener('change', function() {
  if (this.checked) {
    document.querySelector('input[id="warrantyProduct"]').disabled = false;
    // document.querySelector('input[id="warranty_properties"]').disabled = false;
  } else {
    document.querySelector('input[id="warrantyProduct"]').disabled = true;
    // document.querySelector('input[id="warranty_properties"]').disabled = true;
  }
});